import type { BadgeColor } from '@odin-labs/components';
import type { DraftTag, Enforcement } from 'siteLayout';

export const enforcementLabels: Record<Enforcement, string> = {
  ENFORCED: 'Enforced',
  IDENTIFY_ONLY: 'Identify only',
};

export const enforcementHelp =
  'Applies to crossings into this side. Enforced: the reader may deny. Identify only: recorded, never denied.';

export const draftTagBadge = (
  tag: DraftTag,
): { text: string; color: BadgeColor } | null => {
  if (tag === 'NEW') return { text: 'New', color: 'purple' };
  if (tag === 'CHANGED') return { text: 'Changed', color: 'yellow' };
  return null;
};
